import { Button } from '@/components/shadcn/button'
import { IconCloseOutline } from '@icons/IconCloseOutline'
import { Suspense } from 'react'
import { FormFilterContent } from '../Filter'
import { useAppPageState } from '../useAppPageState'
import { IconV2FilterOutline } from '@icons/IconV2FilterOutline'

export function PageFiltersPopoverContent() {
  const { dismissFilterPopover } = useAppPageState()
  return (
    <>
      <div className="-mt-1 mb-2 flex items-start justify-between gap-2 pr-0.5 text-base font-medium">
        <span className="inline-flex items-center gap-3">
          <IconV2FilterOutline className="size-5" />
          <span>Additional Page Filters</span>
        </span>
        <Button
          type="button"
          variant="ghost"
          className="size-7 shrink-0"
          size="icon"
          onClick={dismissFilterPopover}
          aria-label="Close filters"
        >
          <IconCloseOutline className="size-4" />
        </Button>
      </div>
      <div className="flex flex-col gap-y-4">
        <Suspense fallback={<div>Loading...</div>}>
          <FormFilterContent embedInPopover />
        </Suspense>
      </div>
    </>
  )
}
